// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.firebase-upload {
  margin-bottom: 1rem;
}
.firebase-upload .upload-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}
.firebase-upload .upload-document-container {
  border: 2px dashed #bbb;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  background: #fafafa;
}
.firebase-upload .upload-document-container:hover {
  background-color: #f0f8ff;
  border-color: #3b82f6;
}
.firebase-upload .upload-document-container .upload-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #0066cc;
}
.firebase-upload .upload-progress {
  margin-top: 0.5rem;
}
.firebase-upload .upload-progress .progress-bar {
  background: #e0e0e0;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
}
.firebase-upload .upload-progress .progress-bar .progress {
  background: #0066cc;
  height: 100%;
}
.firebase-upload .upload-progress span {
  font-size: 0.8rem;
}
.firebase-upload .uploaded-file {
  margin-top: 0.5rem;
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f0f5ff;
  border-radius: 0.25rem;
}
.firebase-upload .uploaded-file a {
  color: #0066cc;
  text-decoration: underline;
}
.firebase-upload .uploaded-file .cancel-upload-button {
  background: transparent;
  color: red;
  border: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/FireBaseUploader/FirebaseUploader.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AACJ;AAEE;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,yBAAA;EACA,qBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AADN;AAKE;EACE,kBAAA;AAHJ;AAKI;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAHN;AAKM;EACE,mBAAA;EACA,YAAA;AAHR;AAOI;EACE,iBAAA;AALN;AASE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAPJ;AAQI;EACE,cAAA;EACA,0BAAA;AANN;AAQI;EACE,uBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AANN","sourcesContent":[".firebase-upload {\r\n  margin-bottom: 1rem;\r\n\r\n  .upload-label {\r\n    font-weight: 500;\r\n    margin-bottom: 0.5rem;\r\n    display: block;\r\n  }\r\n\r\n  .upload-document-container {\r\n    border: 2px dashed #bbb;\r\n    padding: 1rem;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n\r\n    &:hover {\r\n      background-color: #f0f8ff;\r\n      border-color: #3b82f6;\r\n    }\r\n\r\n    .upload-icon-container {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      color: #0066cc;\r\n    }\r\n  }\r\n\r\n  .upload-progress {\r\n    margin-top: 0.5rem;\r\n\r\n    .progress-bar {\r\n      background: #e0e0e0;\r\n      height: 6px;\r\n      border-radius: 3px;\r\n      overflow: hidden;\r\n\r\n      .progress {\r\n        background: #0066cc;\r\n        height: 100%;\r\n      }\r\n    }\r\n\r\n    span {\r\n      font-size: 0.8rem;\r\n    }\r\n  }\r\n\r\n  .uploaded-file {\r\n    margin-top: 0.5rem;\r\n    padding: 0.5rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background: #f0f5ff;\r\n    border-radius: 0.25rem;\r\n    a {\r\n      color: #0066cc;\r\n      text-decoration: underline;\r\n    }\r\n    .cancel-upload-button {\r\n      background: transparent;\r\n      color: red;\r\n      border: none;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
